import { useSelector } from "react-redux"
import styled from "styled-components"
import backdrop from "../../images/img/backdrop.png"
import { useEffect, useState } from "react";
import moment from "moment";


const Container = styled.div`
    width: calc(100% - 290px);
    height: 70vh;
    border-radius: 10px;
    border: 1px solid ${({theme}) => theme.mainBorderColor};
    background-image: url(${backdrop});
    background-size: contain;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    .chat-container{
        height: calc(100% - 120px);
        width: 100%;
        max-height: 4000px !important;
        overflow: auto;
        padding: 25px;
        position: relative;
        .message{
            background-color: #EFEEEC;
            padding: 10px;
            border-radius: 10px;
            max-width: 70%;
            width: fit-content;
            text-align: left;
            color:  ${({ theme }) => theme.mainTextColor};
            display: flex;
            flex-direction: column;
            gap: 5px;
            .title{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
            }
            .description{
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-md);
                a{
                    color: var(--color-main);
                    text-decoration: underline;
                }
            }
            .date{
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-md);
                width: 100%;
                display: flex;
                justify-content: flex-end;
            }
        }
    }

`

const NotificationMessageSide = () => {
    const {selectedNotification} = useSelector((state) => state.notification)
    const [displayTime, setDisplayTime] = useState("")

    const now = moment();
    const notificationTime = moment(selectedNotification?.createOn);

    useEffect(() => {
        if (now.isSame(notificationTime, "day")) {
            const hoursAgo = now.diff(notificationTime, "hours");
            setDisplayTime(`${hoursAgo} saat önce`);
        } else if (now.subtract(1, "days").isSame(notificationTime, "day")) {
            setDisplayTime(`Dün ${notificationTime.format("HH:mm")}`);
        } else {
            setDisplayTime(notificationTime.format("DD.MM.YYYY HH:mm"));
        }
    },[selectedNotification])

  return (

    <Container>
        <div className="chat-container">
           {
            selectedNotification &&
                <div className="message">
                    <div className="title">{selectedNotification?.title}</div>
                    <div className="description">{selectedNotification?.text} <a href={selectedNotification?.route}>Link.</a></div>
                    <div className="date">{displayTime}</div>
                </div>
           }
           
            
        </div>
        
    </Container>
  )
}

export default NotificationMessageSide